var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('button',{staticClass:"ir-arriba",on:{"click":_vm.scrollToTop}},[_vm._v("↑")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }